import Spinner from 'spin';
import styleMapElements from './styles';

require('node-js-marker-clusterer');
require('svg-pan-zoom');
require('snapsvg');

let globals;

// constructor -------------------------------------------------------
export default ({ mapContainer} = {}) => {
    if (!globals) {
        const google = window.google;
        const InfoBox = window.InfoBox;
        let map;

        const container = document.getElementById(mapContainer);

        if (container !== null) {

            map = new google.maps.Map(container, {
                streetViewControl: false,
                fullscreenControl: false,
                mapTypeControl: false,
                minZoom: 5,
                gestureHandling: 'greedy',
                clickableIcons: false
            });
        }
        // Create blank infowindow element (content called below on marker click event)
        const infoWindow = new google.maps.InfoWindow({
            content: '',
            minWidth: 370,
            maxWidth: 370
        });

        globals = {
            google,
            InfoBox,
            map,
            infoWindow
        };
    }

    return globals;
};

const initSpinner = (mapContainer) => {
  const container = document.querySelector(mapContainer);
  const spinnerShade = document.createElement('div');
  spinnerShade.classList.add('spinner-shade');
  container.appendChild(spinnerShade);
  const spinner = new Spinner({
    lines: 13,
    length: 28,
    width: 14,
    radius: 42,
    scale: 1,
    corners: 1,
    color: '#fff',
    opacity: 0.25,
    rotate: 0,
    direction: 1,
    speed: 1,
    trail: 60,
    fps: 20,
    zIndex: 2e9,
    className: 'spinner',
    top: '50%',
    left: '50%',
    shadow: false,
    hwaccel: false,
    position: 'absolute'
  });
  return {
    start: () => spinner.spin(container),
    stop: () => spinner.stop()
  };
};

